import { InputLocalizationType } from '~src/domains/common/types/forms';
import { createDefaultFormMeta, createFormMetaSlice } from '~src/utils/forms';
import { VerifyFormNames } from '~src/domains/common/enums/common';

export type VerifyLocalization = {
  [key: string]: InputLocalizationType;
};

const formMetaDefault = createDefaultFormMeta([
  [VerifyFormNames.MOBILE_VERIFICATION_CODE, ''],
]);

export const verifyFormSlice = createFormMetaSlice(
  'verifyForm',
  formMetaDefault,
);

export const {
  updateInputValue,
  updateInputHidden,
  updateInputIsValid,
  registerInputLabel,
  registerValidityConfig,
  registerPostProcess,
} = verifyFormSlice.actions;

export default verifyFormSlice.reducer;
